window.CKEDITOR_BASEPATH = baseMedia + 'lib/ckeditor/';
